var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"solid","border-color":"black","border-width":"1px","border-radius":"25px","margin":"20px","padding":"25px"}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-11 h3",staticStyle:{"color":"#545454","margin-left":"0px"}},[_vm._v("\n        "+_vm._s(_vm.graph_title)+"\n      ")]),_c('div',{staticClass:"col-1 d-flex align-items-center justify-content-center",staticStyle:{"margin-bottom":"15px"}},[_c('a',{staticStyle:{"padding-left":"20px"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.update_view_window()}}},[_c('img',{attrs:{"width":"25","src":"/icons/zoom.png"}})])]),_vm._v("\n      "+_vm._s(_vm.graph_desc)+"\n    ")]),(!_vm.loading && !_vm.chart_data)?_c('div',{staticStyle:{"margin-top":"40px"}},[_c('h3',[_vm._v("-no data available-")])]):_vm._e()]),_c('div',[(!_vm.loading && _vm.chart_data)?_c('GChart',{attrs:{"resizeDebounce":0,"type":_vm.chart_type,"data":_vm.chart_data,"options":{
                  height: _vm.graph_height,
                  titleTextStyle: {
                      color: 'black',
                      fontSize: 27,
                      bold: false,
                      italic: false
                  },
                  legend: { position: 'top', alignment: 'center', textStyle: {color: 'black'} },
                  backgroundColor: { fill:'transparent' },
                  //colors: ['#296a9b', 'darkred', '#00a716'],
                  colors: ['#296a9b', 'darkred', '#43459d','#f1ca3a','#6f9654','#e7711b'],
                  hAxis:{
                      gridlines:{ color: 'transparent' },
                      textStyle:{ color: 'black' },
                      titleTextStyle:{ color: 'black', italic: false, fontSize: 18 },
                      baselineColor:{ color: 'black' },
                      format: _vm.date_format
                  },

                  explorer: { actions: ['dragToZoom'], axis: 'horizontal', keepInBounds: true },

                  vAxis:{
                      textStyle:{ color: 'black' },
                      titleTextStyle:{ color: 'black', italic: false, fontSize: 18 },
                      baselineColor:{ color: 'black' },
                      viewWindowMode:'explicit',
                      viewWindow:_vm.vw_window
                  },

                  titlePosition:{ color: 'black' },
                  crosshair:{ color: 'black' }
              },"settings":{ packages: ['corechart'] }}}):_vm._e(),(_vm.loading)?_c('div',{staticStyle:{"height":"150px","margin-top":"260px"}},[_c('div',{staticClass:"text-center text-primary"},[_c('b-spinner',{staticClass:"align-middle"}),_c('strong',{staticStyle:{"margin-left":"20px"}},[_vm._v("Loading...")])],1)]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }